import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmbedVideo } from 'ngx-embed-video';

import { InteractionCompleteRoutingModule } from './interaction-complete-routing.module';
import { InteractionCompleteComponent } from './interaction-complete.component';
import { SharedModule } from 'src/app/components/shared.module';


@NgModule({
  declarations: [InteractionCompleteComponent],
  imports: [
    CommonModule,
    InteractionCompleteRoutingModule,
    EmbedVideo,
    SharedModule
  ]
})
export class InteractionCompleteModule { }
